import { z } from "zod";

export const PaymentMethodSchema = z.enum([
  "PIX",
  "CREDIT_CARD",
  "TED",
  "BOLETO",
]);
export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;
export const PaymentMethod = {
  PIX: "PIX",
  CREDIT: "CREDIT_CARD",
  TED: "TED",
  BOLETO: "BOLETO",
} as const;

export const PaymentStatusSchema = z.enum([
  "CREATED",
  "PENDING",
  "RECEIVED",
  "CONFIRMED",
  "OVERDUE",
  "TED",
  "CHECKOUT_VIEWED",
  "REFUNDED",
  "RECEIVED_IN_CASH",
  "REFUND_REQUESTED",
  "REFUND_IN_PROGRESS",
  "CHARGEBACK_REQUESTED",
  "CHARGEBACK_DISPUTE",
  "AWAITING_CHARGEBACK_REVERSAL",
  "DUNNING_REQUESTED",
  "DUNNING_RECEIVED",
  "AWAITING_RISK_ANALYSIS",
  "DELETED",
]);
export type PaymentStatus = z.infer<typeof PaymentStatusSchema>;

export const PaymentDetailsSchema = z
  .object({
    method: PaymentMethodSchema,
  })
  .catchall(z.any());
export type PaymentDetails = z.infer<typeof PaymentDetailsSchema>;

export const CardBrandSchema = z.enum([
  "visa",
  "mastercard",
  "amex",
  "elo",
  "hipercard",
]);
export type CardBrand = z.infer<typeof CardBrandSchema>;

export const CreditCardFieldKeySchema = z.enum([
  "number",
  "expiry",
  "cvv",
  "holder",
  "installments",
]);
export type CreditCardFieldKey = z.infer<typeof CreditCardFieldKeySchema>;
